module.exports = __webpack_public_path__ + "static/media/refuse.640db485.svg";